import styles from './InfoBlock.module.css';

type InfoBlockProps = {
  readonly title: string;
  readonly children: React.ReactNode;
};

const InfoBlock = ({ title, children }: InfoBlockProps): React.ReactElement => (
  <div className={styles.infoBlock}>
    <h3 className={styles.title}>{title}</h3>
    {children}
  </div>
);

export { InfoBlock };
